export enum SSHConnectionType {
  Direct = "Direct",
  SSHTunnel = "SSH Tunnel",
  CloudAgent = "Cloud Agent",
  AzurePrivateLink = "Azure Private Link",
}
